module.exports = __webpack_public_path__ + "img/14.6e8e2ce4.svg";